// extracted by mini-css-extract-plugin
export default {"main":"PartnersSection_main__U6V45","headerText":"PartnersSection_headerText__qfVlq","eachSlide":"PartnersSection_eachSlide__9+NZI"};